<script lang="ts">
  // Components
  import { Icon } from '$lib/components/atoms/Icon';

  export let title: string
  export let text: string
  export let allowNative = false
  export let hideOnMobile = false

  let showFallbackPanel = false

  const showSharePanel = () => {
    if (allowNative && "share" in navigator) {
      navigator.share({
        title,
        text,
        url: window.location.href,
      })
    } else {
      showFallbackPanel = !showFallbackPanel
    }
  }

  const shareLink = (social: string) => {
    const url = window.location.href
    switch (social) {
      case "facebook":
        return `https://www.facebook.com/sharer/sharer.php?u=${url}&t=${title}}`
      case "twitter":
        return `https://twitter.com/share?url=${url}&text=${title}`
      case "linkedin":
        return `https://www.linkedin.com/sharing/share-offsite/?url=${url}`
    }
  }
</script>

<div class="share-button-container" class:v-no-mobile="{hideOnMobile}">
  <button class="share-button" class:active="{showFallbackPanel}" on:click="{showSharePanel}">
    <Icon icon="share" />
  </button>

  {#if showFallbackPanel}
    <div class="share-panel space-x-3">
      <a href="{shareLink('facebook')}" class="share-link-btn" target="_blank" rel="noreferrer noopener">
        <Icon icon="facebook" />
      </a>
      <a href="{shareLink('twitter')}" class="share-link-btn" target="_blank" rel="noreferrer noopener">
        <Icon icon="twitter" />
      </a>
      <a href="{shareLink('linkedin')}" class="share-link-btn" target="_blank" rel="noreferrer noopener">
        <Icon icon="linkedin" />
      </a>
    </div>
  {/if}
</div>

<style type="text/scss" lang="scss" scoped>
  .share-button-container {
    @apply relative;
    @apply flex justify-end;
    &.v-no-mobile {
      @apply hidden md:flex;
    }
  }

  .share-button {
    @apply appearance-none;
    @apply w-12 h-12 rounded-full;
    @apply border border-gray-900;
    @apply flex items-center justify-center;
    @apply transition-colors duration-300;
    @apply outline-none focus:outline-none focus:shadow-none;
    @apply focus:ring-2 focus:ring-offset-2 focus:ring-brand;

    &:hover,
    &.active {
      @apply bg-gray-900 text-white;
    }
  }

  .share-panel {
    @apply absolute right-14 top-1/2;
    @apply transform -translate-y-1/2;
    @apply flex items-center;
    @apply bg-white rounded;
    @apply p-4;
  }

  .share-link-btn {
    @apply w-6 h-6 p-0;
    @apply outline-none focus:outline-none focus:shadow-none;
    @apply focus:ring-2 focus:ring-offset-2 focus:ring-brand;
  }
</style>
